import * as ActionTypes from '../ActionTypes';

const componentInitialState = {
    isLoading: false,
    success: false,
    error: false,
    payrollApproverLoading: false,
    payroll_approver_data: [],
    payrollTileViewLoading: false,
    payroll_tile_view_data: [],
};


export const PayrollManagementReducer = function (state = componentInitialState, action) {
     switch (action.type) {
        case ActionTypes.PAYROLL_APPROVER_GET_REQUEST:
            return {
                ...state,
                payrollApproverLoading: true,
                success: false,
                error: false,
                payroll_approver_data: []
            };
        case ActionTypes.PAYROLL_APPROVER_UPDATE_REQUEST:
            return {
                ...state,
                payrollApproverLoading: true,
                success: false,
                error: false,
            };
        case ActionTypes.PAYROLL_APPROVER_GET_SUCCESS:
        case ActionTypes.PAYROLL_APPROVER_UPDATE_SUCCESS:
            return {
                ...state,
                payrollApproverLoading: false,
                success: true,
                successMessage: action.payload?.message,
                payroll_approver_data: action.payload?.data?.data?.[0],
            };
        case ActionTypes.PAYROLL_APPROVER_GET_ERROR:
        case ActionTypes.PAYROLL_APPROVER_UPDATE_ERROR:
            return {
                ...state,
                payrollApproverLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };
        case ActionTypes.PAYROLL_TILE_VIEW_GET_REQUEST:
            return {
                ...state,
                payrollTileViewLoading: true,
                success: false,
                error: false,
                payroll_tile_view_data: []
            };

        case ActionTypes.PAYROLL_TILE_VIEW_GET_SUCCESS:
            return {
                ...state,
                payrollTileViewLoading: false,
                success: true,
                payroll_tile_view_data: action.payload?.data?.data || [],
                successMessage: action.payload?.message,
            };

        case ActionTypes.PAYROLL_TILE_VIEW_GET_ERROR:
            return {
                ...state,
                payrollTileViewLoading: false,
                error: true,
                success: false,
                errorMessage: action.payload?.data?.error?.[0]?.message,
            };
        default:
            return state;
    }
};